// i18n translations
import { useTranslation } from 'react-i18next';

// i18n-iso-countries
import countries from 'i18n-iso-countries';

// Register language locales (add more as needed)
import enLocale from 'i18n-iso-countries/langs/en.json';
import arLocale from 'i18n-iso-countries/langs/ar.json';

countries.registerLocale(enLocale);
countries.registerLocale(arLocale);

/**
 * Hook for translating country names using local translation library
 */
export const useCountryTranslation = () => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  /**
   * Get translated country name using local library
   * @param countryName - Original country name in English (fallback)
   * @param countryCode - ISO3 country code
   * @returns Translated country name or original if translation not available
   */
  const getCountryName = (countryName: string, countryCode: string): string => {
    // If current language is English, return original name
    if (currentLanguage === 'en') {
      return countryName;
    }

    try {
      // Use i18n-iso-countries to get translated name
      const translatedName = countries.getName(countryCode, currentLanguage);

      // Return translated name if available, otherwise fallback to original
      return translatedName || countryName;
    } catch (error) {
      // Return original name if translation fails
      return countryName;
    }
  };

  return {
    getCountryName,
    currentLanguage,
  };
};
